import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=e3917230"
import script from "./SideNav.vue?vue&type=script&lang=ts"
export * from "./SideNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports